import { axiosReq } from "utils";
import { ChallengeMainActions } from "./ChallengeMainReducer";
import { toast } from "sonner";

export const getChallengesRequest = (getToken) => async (dispatch) => {
  const token = await getToken();
  try {
    dispatch(ChallengeMainActions.getChallengesRequest());
    const response = await axiosReq({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_URL}/equity/historyByUser`,
      headers: {
        Authorization: `Bearer ${token}`,
      },

      withCredentials: true,
    });

    dispatch(ChallengeMainActions.getChallengesSuccess(response.data));
  } catch (error) {
    dispatch(
      ChallengeMainActions.getChallengesError(
        error?.message || error?.response?.data?.message
      )
    );
  }
};

export const getClosedChallenges = (getToken) => async (dispatch) => {
  const token = await getToken();
  try {
    dispatch(ChallengeMainActions.getClosedChallengesRequest());
    const response = await axiosReq({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_URL}/equity/historyByUser`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        status: "BREACHED",
      },
      withCredentials: true,
    });

    dispatch(ChallengeMainActions.getClosedChallengesSuccess(response.data));
  } catch (error) {
    dispatch(
      ChallengeMainActions.getClosedChallengesError(
        error?.message || error?.response?.data?.message
      )
    );
  }
};

export const emptyChartData = () => (dispatch) => {
  dispatch(ChallengeMainActions.emptyChartData());
};
export const getPositions = (getToken) => async (dispatch) => {
  const token = await getToken();
  try {
    dispatch(ChallengeMainActions.getPositionsRequest());
    const response = await axiosReq({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_URL}/position/ByUser`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    dispatch(ChallengeMainActions.getPositionsSuccess(response.data));
  } catch (error) {
    dispatch(
      ChallengeMainActions.getPositionsError(
        error?.message || error?.response?.data?.message
      )
    );
  }
};

export const getChallengeInfo = (getToken, challengeId) => async (dispatch) => {
  const token = await getToken();
  try {
    dispatch(ChallengeMainActions.getChallengeInfoRequest());
    const response = await axiosReq({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_URL}/challenge/info/${challengeId}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    dispatch(ChallengeMainActions.getChallengeInfoSuccess(response.data));
  } catch (error) {
    toast.error(error?.message || error?.response?.data?.message, {
      autoClose: 2000,
      className: "bg-red-opacity text-red",
    });
    dispatch(
      ChallengeMainActions.getChallengeInfoError(
        error?.message || error?.response?.data?.message
      )
    );
  }
};
